import { AppRoutes, PageNames } from 'routes';

import { appRoutesByLocal } from '../localization';

let allLocaleRoutesByid = null;

export const generateRoutes = () => {
    const baseRoutes = {};
    for (let [locale, routesByid] of Object.entries(appRoutesByLocal)) {
        routesByid = Object.assign({}, routesByid);
        delete routesByid['routes.base'];
        delete routesByid['routes.page.not.found'];
        Object.values(routesByid).forEach((path) => {
            baseRoutes[path] = locale;
        });
    }

    return baseRoutes;
};

export const getAllRoutesById = (ids) => {
    if (!allLocaleRoutesByid) {
        allLocaleRoutesByid = generateAllRoutesById();
    }
    const routes = [];

    ids.forEach((id) => {
        routes.push(...allLocaleRoutesByid[id]);
    });
    return routes;
};

export const getRouteId = (route) => {
    if (!allLocaleRoutesByid) {
        allLocaleRoutesByid = generateAllRoutesById();
    }
    route = normalizeRoute(route);
    for (let [id, routes] of Object.entries(allLocaleRoutesByid)) {
        if (routes.includes(route)) {
            return id;
        }
    }
};

export const getPageName = (route) => {
    const routeId = getRouteId(route);
    for (let routeName in AppRoutes) {
        if (AppRoutes[routeName] === routeId) {
            return PageNames[routeName];
        }
    }
};

export const normalizeRoute = (route) => {
    route = route.substring(3); // remove locale '/en' from the route
    if (!route || route === '/') {
        return '/';
    }
    /**
     * remove trailing '/' to match our route nomenclature
     */
    const lastSlashIndex = route.lastIndexOf('/');
    if (lastSlashIndex && lastSlashIndex === route.length - 1) {
        route = route.slice(0, lastSlashIndex);
    }

    return route;
};

const generateAllRoutesById = () => {
    const routesById = {};
    for (const routes of Object.values(appRoutesByLocal)) {
        Object.entries(routes).forEach(([id, route]) => {
            if (!routesById[id]) {
                routesById[id] = [];
            }

            if (!routesById[id].includes(route)) {
                routesById[id].push(route);
            }
        });
    }
    return routesById;
};
